package com.ppfc_bot.web.web

import kotlin.Long
import kotlin.String

public object BuildConfig {
  public const val API_BASE_ADDRESS: String = "http://ppfc.us-east-2.elasticbeanstalk.com/api/"

  public const val LOG_LEVEL: Long = 6
}
